module.exports = __webpack_public_path__ + "img/block-3.f0c17bf9.svg";